module.exports = __webpack_public_path__ + "img/mirk-accounting.4ec510a5.jpg";